import React, { Component } from 'react';
import './App.css';
import './index.css';

export default class BathroomRating extends Component {

    render() {
        return (
            <div className="bathroomContent">
                <p>{this.props.bathroom}</p>
                {this.props.rating === 1 &&
                    <div>
                        <img src="toiletpaper1.png" alt="Nasty Toilet Paper"/>
                    </div>
                }
                {this.props.rating === 2 &&
                    <div>
                        <img src="toiletpaper2.png" alt="Frowning Toilet Paper" />
                        <img src="toiletpaper2.png" alt="Frowning Toilet Paper" />
                    </div>
                }
                {this.props.rating === 3 &&
                    <div>
                        <img src="toiletpaper3.png" alt="Ambivalent Toilet Paper" />
                        <img src="toiletpaper3.png" alt="Ambivalent Toilet Paper" />
                        <img src="toiletpaper3.png" alt="Ambivalent Toilet Paper" />
                    </div>
                }
                {this.props.rating === 4 &&
                    <div>
                        <img src="toiletpaper4.png" alt="Smiling Toilet Paper" />
                        <img src="toiletpaper4.png" alt="Smiling Toilet Paper" />
                        <img src="toiletpaper4.png" alt="Smiling Toilet Paper" />
                        <img src="toiletpaper4.png" alt="Smiling Toilet Paper" />
                    </div>
                }
                {this.props.rating === 5 &&
                    <div>
                        <img src="toiletpaper5.png" alt="Very Happy Toilet Paper" />
                        <img src="toiletpaper5.png" alt="Very Happy Toilet Paper" />
                        <img src="toiletpaper5.png" alt="Very Happy Toilet Paper"  />
                        <img src="toiletpaper5.png" alt="Very Happy Toilet Paper" />
                        <img src="toiletpaper5.png" alt="Very Happy Toilet Paper" />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/BathroomRating.js